// Pure TTS-input utilities (no DOM/IndexedDB deps so this is safe to import
// from Node-side scripts and tests).

const KANA_RANGE_REGEX = /^[぀-ゟ゠-ヿ]+$/;

// Append a Japanese full stop to short bare-kana strings so Wavenet doesn't
// clip the trailing mora. Covers gojūon (1 char) and yōon (2 chars).
export function padForTTS(text: string): string {
  if (text.length > 0 && text.length <= 2 && KANA_RANGE_REGEX.test(text)) {
    return text + '。';
  }
  return text;
}
